import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

const SIZES = [10, 50, 100];

// Client-side pagination for dense list views: returns the page slice + props for <ListPagination />.
export function usePager(items) {
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const total = items.length;
  const pageCount = Math.max(1, Math.ceil(total / perPage));
  useEffect(() => { setPage(0); }, [perPage, total]);
  const clamped = Math.min(page, pageCount - 1);
  return {
    pageItems: items.slice(clamped * perPage, clamped * perPage + perPage),
    pagerProps: { page: clamped, pageCount, total, perPage, setPage, setPerPage },
  };
}

// Standard table footer: "Items per page" selector (10/50/100) + Prev/Next. See design_guidelines.json R5.
export function ListPagination({ page, pageCount, total, perPage, setPage, setPerPage, testid }) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 px-3 py-2 border-t border-slate-100 text-xs text-slate-500" data-testid={testid}>
      <div className="inline-flex items-center gap-2">
        <span>Items per page</span>
        <select
          value={perPage}
          onChange={(e) => setPerPage(Number(e.target.value))}
          className="h-7 text-xs border border-slate-200 rounded-md px-1.5 bg-white"
          data-testid={`${testid}-per-page`}
        >
          {SIZES.map((n) => <option key={n} value={n}>{n}</option>)}
        </select>
      </div>
      <div className="inline-flex items-center gap-2">
        <span data-testid={`${testid}-info`}>Page {page + 1} of {pageCount} · {total} item(s)</span>
        <Button size="sm" variant="outline" className="h-7 text-[11px]" disabled={page === 0} onClick={() => setPage(page - 1)} data-testid={`${testid}-page-prev`}>Prev</Button>
        <Button size="sm" variant="outline" className="h-7 text-[11px]" disabled={page >= pageCount - 1} onClick={() => setPage(page + 1)} data-testid={`${testid}-page-next`}>Next</Button>
      </div>
    </div>
  );
}
